'use client';

import { useEffect } from 'react';

/**
 * Bumps the view counter na page load.
 *
 * Fire-and-forget: faalt stil. Bewust géén sessionStorage dedup omdat we
 * uniqueness niet zo zwaar wegen — herhaalde views door dezelfde lezer
 * zijn ook indicatief voor "interesse".
 */
export function ArticleViewCounter({ slug }: { slug: string }) {
  useEffect(() => {
    fetch(`/api/articles/${encodeURIComponent(slug)}/view`, { method: 'POST' }).catch(() => {});
  }, [slug]);
  return null;
}
